import React from 'react'
import getMomentDateObj from '../functions/getMomentDateObj'
import getTranslationTime from '../functions/getTranslationTime'
import isCurrentPerformance from '../functions/isCurrentPerformance'
import ReactScrollLink from '../General/ReactScollLink'
import sortPerformancesByDate from '../functions/sortPerformancesByDate'
import Translation from '../General/Translation'
import MovieTimesPeriodeDaysItemAttributesContainer from './MovieTimesPeriodeDaysItemAttributesContainer'
import AlternativeLinkButton from './AlternativeLinkButton'

const MovieTimesPeriodeDaysItemsDesktop = ({
    movieId, 
    movieTitle, 
    hideTheatres = true, 
    performances, 
    showPerformancePrice, 
    activePerformance, 
    translation, 
    additionalClass='', 
    scrollToPosition, 
    alternativeLink,
    onOpenIframe, 
    noIframe=false, 
    showAttributes=false, 
    dateNow
}) => {
    const sortedPerf = sortPerformancesByDate(performances)
    const {locale } = translation
    
    return sortedPerf.map((performance, index) => {
        const { id, timeUtc, deeplinkURL,attributes, cinema, theatreName, priceInfo, seatClasses } = performance
        const activePerformanceDateClass = activePerformance && id === activePerformance.id ? ' active-performance-date' : ''
        const showtime = getTranslationTime('showtimePerformance', translation, timeUtc)

        let priceToDisplay = false

        if(priceInfo && showPerformancePrice) {
            if(priceInfo[showPerformancePrice]) {
                const price = priceInfo[showPerformancePrice]
                const priceConverted = price ? price.amount.toLocaleString(locale, {style:"currency", currency: price.currency}) : null
                priceToDisplay = priceConverted
            }
        }

        if(isCurrentPerformance(dateNow, getMomentDateObj(timeUtc, translation.timezone))) {
            if(alternativeLink) {
                return <AlternativeLinkButton
                    showShowtimes={true}
                    key={index}
                    translation={translation}
                    alternativeLink={alternativeLink}
                    showPerformancePrice={showPerformancePrice} 
                    performances={sortedPerf}
                    className={'text-bold-grey-showtimes-desktop'}
                />
            } else if(noIframe) {
                return (
                    <a key={index} href={deeplinkURL} rel="noreferrer" target="_blank" className={"show-wrapper theme-radius-posters-full cursor-pointer" + additionalClass}>
                        <span className="text-bold-grey showtime">{showtime}</span>
                        {showPerformancePrice && priceToDisplay && <span className="text-light performance-price"><Translation id="from" trans={translation}>Ab</Translation> {priceToDisplay}</span>}
                    </a>
                )
            } else {
                return (
                    <ReactScrollLink 
                        className={'show-wrapper theme-radius-posters-full cursor-pointer' + additionalClass + activePerformanceDateClass}
                        key={index} 
                        to={scrollToPosition + ' performance-iframe'} 
                        smooth={true} 
                        offset={-200} 
                        onClick={() => onOpenIframe({
                            id: id,
                            timeUtc: timeUtc,
                            url: deeplinkURL,
                            movieId: movieId,
                            movieTitle: movieTitle,
                            cinema: cinema
                        })}
                    >
                        <span className="text-bold-grey-showtimes-desktop showtime">{showtime}</span>
                        {showPerformancePrice && priceToDisplay && <span className="text-light performance-price"><Translation id="from" trans={translation}>Ab</Translation> {priceToDisplay}</span>}
                        {showAttributes && <MovieTimesPeriodeDaysItemAttributesContainer seatClasses={seatClasses} theatreName={theatreName} hideTheatres={hideTheatres} attributes={attributes} cinema={cinema}/>}
                    </ReactScrollLink>
                )
            }
        }
    })
}

export default MovieTimesPeriodeDaysItemsDesktop
    